import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { useState, useEffect } from "react";
import * as Yup from "yup";
import appStyles from "../../../../../app.module.css";
import AppUtil from "../../../../classes/util";
import ErrorMsg from "../../../../components/error-msg/error-msg";

const initialValues = {
  min_price: "",
  max_price: "",
  stamp_duty: "",
  amount: "",
};

const AddEditResidentialRate = (props) => {
  const [validationSchema, setValidationSchema] = useState(null);
  const { residentialRates, residentialRate, error } = props;

  useEffect(() => {
    setValidationSchema(
      Yup.object().shape({
        min_price: Yup.number()
          .required("Minimum price is required")
          .min(0, "Minimum price is required")
          .test("min_price", "Range is overlapping", (value) => {
            return AppUtil.rangeValidator(
              value,
              residentialRate?.id,
              residentialRates
            );
          }),
        max_price: Yup.number()
          // .required("Maximum price is required")
          .moreThan(0, "Maximum price must be greater than 0")
          .when("min_price", {
            is: (min_price) => min_price || min_price === 0,
            then: Yup.number()
              .min(
                Yup.ref("min_price"),
                "Maximum price must be greater than to minimum price"
              )
              .test("max_price", "Range is overlapping", (value) => {
                return AppUtil.rangeValidator(
                  value,
                  residentialRate?.id,
                  residentialRates
                );
              }),
          }),
        stamp_duty: Yup.number()
          .required("Stamp duty is required")
          .min(0, "Stamp duty is required"),
        amount: Yup.number()
          .required("Amount is required")
          .min(0, "Amount is required"),
      })
    );
  }, [residentialRate.id, residentialRates]);

  const onSubmit = (values) => {
    props.submit(values);
  };

  return (
    validationSchema && (
      <>
        <div className={appStyles.rezziModal}>
          <div className={appStyles.rezziModalOverlay}></div>
          <div className={appStyles.rezziModalContent}>
            <Formik
              initialValues={
                residentialRate.id ? residentialRate : initialValues
              }
              validationSchema={validationSchema}
              onSubmit={onSubmit}
            >
              {({ values, touched, errors }) => (
                <Form>
                  <div className={appStyles.rezziModalHeader}>
                    <h2
                      className={`${appStyles.textCenter} ${appStyles.colorPrimary}`}
                    >
                      {residentialRate.id
                        ? "Edit Residential Rate"
                        : "Add Residential Rate"}
                    </h2>
                  </div>
                  <div className={appStyles.rezziModalBody}>
                    <div className={appStyles.formRow}>
                      <div
                        className={`${appStyles.formField} ${
                          values.min_price || values.min_price === 0
                            ? appStyles.hasValue
                            : ""
                        } ${
                          touched.min_price && errors.min_price
                            ? appStyles.hasError
                            : ""
                        }`}
                      >
                        <Field type="number" id="min_price" name="min_price" />
                        <label htmlFor="min_price">Minimum Price</label>
                        <ErrorMessage name="min_price" component={ErrorMsg} />
                      </div>
                    </div>
                    <div className={appStyles.formRow}>
                      <div
                        className={`${appStyles.formField} ${
                          values.max_price || values.max_price === 0
                            ? appStyles.hasValue
                            : ""
                        } ${
                          touched.max_price && errors.max_price
                            ? appStyles.hasError
                            : ""
                        }`}
                      >
                        <label htmlFor="max_price">Maximum Price</label>
                        <Field type="number" id="max_price" name="max_price" />
                        <ErrorMessage name="max_price" component={ErrorMsg} />
                      </div>
                    </div>
                    <div className={appStyles.formRow}>
                      <div
                        className={`${appStyles.formField} ${
                          values.stamp_duty || values.stamp_duty === 0
                            ? appStyles.hasValue
                            : ""
                        } ${
                          touched.fee && errors.stamp_duty
                            ? appStyles.hasError
                            : ""
                        }`}
                      >
                        <Field
                          type="number"
                          id="stamp_duty"
                          name="stamp_duty"
                        />
                        <label htmlFor="stamp_duty">Stamp Duty</label>
                        <ErrorMessage name="stamp_duty" component={ErrorMsg} />
                      </div>
                    </div>
                    <div className={appStyles.formRow}>
                      <div
                        className={`${appStyles.formField} ${
                          values.amount || values.amount === 0
                            ? appStyles.hasValue
                            : ""
                        } ${
                          touched.amount && errors.amount
                            ? appStyles.hasError
                            : ""
                        }`}
                      >
                        <label htmlFor="amount">Amount</label>
                        <Field type="number" id="amount" name="amount" />
                        <ErrorMessage name="amount" component={ErrorMsg} />
                      </div>
                    </div>
                  </div>
                  <div className={appStyles.rezziModalFooter}>
                    <button type="submit">Save</button>
                    <button
                      className={appStyles.buttonOutline}
                      onClick={props.close}
                    >
                      Close
                    </button>
                  </div>
                  {error && (
                    <div className={appStyles.colorDanger}>{error}</div>
                  )}
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </>
    )
  );
};

export default AddEditResidentialRate;
